// https://github.com/scttcper/ngx-emoji-mart#i18n
export enum EmojiPickerCategories {
    Search = 'search',
    Recent = 'recent',
    People = 'people',
    Nature = 'nature',
    Foods = 'foods',
    Activity = 'activity',
    Places = 'places',
    Objects = 'objects',
    Symbols = 'symbols',
    Flags = 'flags',
    Custom = 'custom',
}

export enum EmojiPickerData {
    SheetSize = 32,
    EmojiSize = 32,
    Set = 'apple',
    EmojiChatSize = 20,
    EmojisPerLineDesktop = 7,
    EmojisPerLineMobile = 6,
}
